export const ROLE = {
  SSA: 'SSA', // super admin (global)
  SA: 'SA', // main admin
  VP: 'VP', // school admin
  TRADMIN: 'TRADMIN',
  MD: 'MD',
  STD: 'STD',
};

/** WRC / NRC / SRC / MRC / ERC */
export function isRegionalCoordinator(code) {
  return typeof code === 'string' && code.includes('RC');
}

/**
 * Чинит падение на старом `role?.code.includes('RC')` — опциональная цепочка
 * обрывается на `code`, поэтому роль с `code === undefined` роняла навбар.
 */
export function getRoleCodes(user) {
  return (user?.roles || [])
    .map((r) => r?.code)
    .filter((c) => typeof c === 'string');
}

export function hasRole(user, code) {
  return getRoleCodes(user).includes(code);
}

export function isSSA(user) {
  return hasRole(user, ROLE.SSA);
}

/** Раздел «Формы» (/forms и редактор формы) открыт только SSA и TRADMIN. */
export function canOpenForms(user) {
  return hasRole(user, ROLE.SSA) || hasRole(user, ROLE.TRADMIN);
}
